export interface IRegionsState {}

let regionsState: IRegionsState = {};

export default regionsState;